import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {ContentContext} from 'modules/content/context';
import {ContentPage} from 'modules/content/pages/ContentPage';
import {selectContentPage} from 'modules/content/selectors';
import React from 'react';

export const ContentProvider = () => {
    const content = useAppSelector(selectContentPage);

    if (!content) {
        return null;
    }

    return (
        <ContentContext.Provider value={content}>
            <ContentPage />
        </ContentContext.Provider>
    );
};
